import TicketCreateEventDetails from './TicketCreateEventDetails';

export default TicketCreateEventDetails;
